import React from 'react';
import { ChevronRight, Library } from 'lucide-react';

export const LibraryBreadcrumbs = ({ trail = [], onOpen }) => (
  <nav className="flex items-center flex-wrap gap-1 text-sm" aria-label="Folder path" data-testid="library-breadcrumbs">
    <button onClick={() => onOpen('')}
      className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-md transition-colors hover:bg-white/5 ${trail.length ? 'text-[hsl(var(--text-muted))]' : 'text-[hsl(var(--text-primary))] font-semibold'}`}
      data-testid="breadcrumb-root">
      <Library size={14} /> Library
    </button>
    {trail.map((f, i) => {
      const last = i === trail.length - 1;
      return (
        <React.Fragment key={f.id}>
          <ChevronRight size={14} className="text-[hsl(var(--text-muted))]" />
          <button onClick={() => !last && onOpen(f.id)} disabled={last}
            className={`px-2 py-1 rounded-md max-w-[220px] truncate transition-colors ${last ? 'text-[hsl(var(--text-primary))] font-semibold cursor-default' : 'text-[hsl(var(--text-muted))] hover:bg-white/5'}`}
            data-testid={`breadcrumb-${f.id}`}>
            {f.name}
          </button>
        </React.Fragment>
      );
    })}
  </nav>
);
